import React from "react";

import { Compass } from "lucide-react";
import { useNavigate } from "react-router-dom";

import Button from "../../Components/Button";
import { useLogout } from "../../Hooks/useLogout";

import "./style.scss";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const logoutSession = useLogout();

  const handlePrimaryAction = () => {
    navigate("/");
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-100 px-4">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-indigo-200/35 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-cyan-200/30 blur-3xl" />
      </div>

      <div className="relative mx-auto flex min-h-[calc(100vh-64px)] w-full max-w-4xl items-center justify-center">
        <div className="not-found-card relative w-full max-w-2xl rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-[0_18px_45px_rgba(15,23,42,0.10)] sm:p-12">
          <div className="absolute left-1/2 top-10 -translate-x-1/2 text-[110px] font-black leading-none text-slate-100 select-none sm:text-[140px]">
            404
          </div>
          <div className="relative mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-indigo-200 bg-indigo-50 px-4 py-1.5 text-sm font-semibold text-indigo-700">
            <Compass size={16} />
            Error 404
          </div>

          <div className="relative mb-3 text-4xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl">
            Page not found
          </div>
          <p className="relative mx-auto mb-8 max-w-xl text-base leading-8 text-slate-600 sm:text-[17px]">
            The page you are trying to reach does not exist, may have been
            moved, or is temporarily unavailable.
          </p>

          <div className="mx-auto mb-9 h-px w-full max-w-md bg-slate-200" />

          <div className="button-wrapper">
            <Button
              type="button"
              onClick={handlePrimaryAction}
              className="home-button"
            >
              Home
            </Button>
            <Button
              type="button"
              onClick={logoutSession}
              className="logout-button"
              variant="white"
            >
              Log out
            </Button>
          </div>

          <div className="mt-6 text-sm leading-6 text-slate-500">
            If this issue continues, please contact your administrator.
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
